import { useState, useEffect } from 'react';
const DEFAULT_MOBILE_BREAKPOINT = '(max-width: 717px)';
export const useIsMobile = (breakpoint = DEFAULT_MOBILE_BREAKPOINT) => {
    const [isMobile, setIsMobile] = useState(() => window.matchMedia(breakpoint).matches);
    useEffect(() => {
        const mq = window.matchMedia(breakpoint);
        const handler = (e) => setIsMobile(e.matches);
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, [breakpoint]);
    return isMobile;
};
//# sourceMappingURL=useIsMobile.js.map